module.exports = __webpack_public_path__ + "img/logo_sala.png_color.8c7c9a21.png";